import * as React from 'react'
import { QueryClientProvider } from 'react-query'
import buildQueryClient from '../helpers/queryClient'
import Overview from './Overview'
import CommonContext, { CommonContextType } from '../CommonContext'
import { useState } from 'react'

type ProductPlanningAppProps = {
  area: string
  availableAreas: string[]
  availableUsers: CommonContextType['availableUsers']
  currentUser: CommonContextType['currentUser']
}

export default function ProductPlanningApp(props: ProductPlanningAppProps) {
  const queryClient = buildQueryClient()

  const [dictionaries, setDictionaries] = useState<CommonContextType>({
    availableAreas: props.availableAreas,
    availableUsers: props.availableUsers,
    currentUser: props.currentUser,
    updateCurrentUser: user => {
      setDictionaries({ ...dictionaries, currentUser: user })
    },
  })

  return (
    <CommonContext.Provider value={dictionaries}>
      <QueryClientProvider client={queryClient}>
        <div className="pt-3">
          <Overview {...props} />
        </div>
      </QueryClientProvider>
    </CommonContext.Provider>
  )
}
